import { render, staticRenderFns } from "./StagingPopup.vue?vue&type=template&id=3a65c65a&scoped=true&"
import script from "./StagingPopup.vue?vue&type=script&lang=js&"
export * from "./StagingPopup.vue?vue&type=script&lang=js&"
import style0 from "./StagingPopup.vue?vue&type=style&index=0&id=3a65c65a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a65c65a",
  null
  
)

export default component.exports